import { render, staticRenderFns } from "./ServiceEnroll.vue?vue&type=template&id=ec945cd4&scoped=true&"
import script from "./ServiceEnroll.vue?vue&type=script&lang=js&"
export * from "./ServiceEnroll.vue?vue&type=script&lang=js&"
import style0 from "./ServiceEnroll.vue?vue&type=style&index=0&id=ec945cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec945cd4",
  null
  
)

export default component.exports